export default function(goods) {
  if (!Array.isArray(goods) || goods.length < 1) return;
  const count = goods.reduce((acc, val) => acc + +val.count, 0);
  const arrCart = document.querySelectorAll('div.btn-cart span');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < arrCart.length; i++) {
    arrCart[i].innerHTML = count;
    if (count > 0) {
      arrCart[i].style['background-color'] = '#f17811';
    }
  }
}
